import { Flex } from '@pancakeswap/uikit'
import { useEffect, useRef, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import SearchInput from './SearchInput'
import SearchResult from './SearchResult'

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`

const fadeOverlay = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const Container = styled(Flex)`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  animation: ${fadeOverlay} 0.3s ease-out;
`
const Wrapper = styled(Flex)`
  display: flex;
  width: 791px;
  height: 525px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(64px);
  animation: ${fadeIn} 0.3s ease-out;
`

const SearchModal = ({
  onClose,
  onChangeSearchInput,
}: {
  onClose: () => void
  onChangeSearchInput: (value: string) => void
}) => {
  const [activeFilter, setActiveFilter] = useState<number>(0)
  const wrapperRef = useRef<HTMLDivElement>(null)

  const handleFilterClick = (index: number) => {
    setActiveFilter(index)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  return (
    <Container>
      <Wrapper ref={wrapperRef}>
        <SearchInput onClose={onClose} onChangeSearchInput={onChangeSearchInput} />
        <SearchResult activeFilter={activeFilter} onClickFilter={handleFilterClick} />
      </Wrapper>
    </Container>
  )
}

export default SearchModal
